<template>
  <section class="border-t border-default/60 bg-default">
    <UContainer class="py-12 sm:py-14">
      <div class="mx-auto max-w-md space-y-4">
        <h2
          v-if="title"
          class="text-center text-xl font-semibold text-highlighted"
        >
          {{ title }}
        </h2>
        <p
          v-if="subtitle"
          class="text-center text-sm text-muted"
        >
          {{ subtitle }}
        </p>
        <div
          v-if="!magnetId || builderPreview"
          class="rounded-2xl border border-dashed border-primary/30 p-6 text-center text-sm text-muted"
        >
          محتوای رایگان
        </div>
        <LeadFlowShell
          v-else
          :labels="labels"
          :step="step"
          :loading="saving"
          :next-disabled="nextDisabled"
          :next-label="step === 0 ? 'دریافت' : 'دانلود'"
          @next="next"
          @back="step = 0"
        >
          <template v-if="step === 0">
            <UFormField
              v-if="requireName"
              label="نام"
            >
              <UInput v-model="name" />
            </UFormField>
            <AuthPhoneInput v-model="phone" />
          </template>
          <div
            v-else
            class="space-y-3 text-center"
          >
            <p class="text-sm text-primary">
              {{ thankYou || 'لینک دانلود آماده است.' }}
            </p>
            <UButton
              v-if="downloadUrl"
              :to="downloadUrl"
              external
              block
            >
              دانلود فایل
            </UButton>
          </div>
        </LeadFlowShell>
        <p
          v-if="error"
          class="text-center text-sm text-error"
        >
          {{ error }}
        </p>
      </div>
    </UContainer>
  </section>
</template>

<script setup lang="ts">
import AuthPhoneInput from '~/components/auth/PhoneInput.vue'
import { isCompleteIrMobile } from '~/utils/phone'
import { apiErrorMessage } from '~/utils/apiError'

const props = defineProps<{
  title?: string
  subtitle?: string
  magnetId?: string
  builderPreview?: boolean
}>()

const phone = ref('')
const name = ref('')
const step = ref(0)
const saving = ref(false)
const error = ref('')
const downloadUrl = ref('')
const thankYou = ref('')
const requireName = ref(false)
const labels = ['موبایل', 'دانلود']

if (import.meta.client && props.magnetId && !props.builderPreview) {
  $fetch<{ item: { requireName?: boolean } }>(`/api/leads/magnets/${props.magnetId}`)
    .then((res) => { requireName.value = Boolean(res.item.requireName) })
    .catch(() => {})
}

const nextDisabled = computed(() => step.value === 0 && (!isCompleteIrMobile(phone.value) || (requireName.value && !name.value.trim())))

async function next() {
  if (step.value === 1 || !props.magnetId || props.builderPreview) return
  saving.value = true
  error.value = ''
  try {
    const res = await $fetch<{ item: { downloadUrl: string; thankYouMessage: string } }>(`/api/leads/magnets/${props.magnetId}/submit`, {
      method: 'POST',
      body: { phone: phone.value, name: name.value || undefined },
    })
    downloadUrl.value = res.item.downloadUrl
    thankYou.value = res.item.thankYouMessage
    step.value = 1
  }
  catch (err) {
    error.value = apiErrorMessage(err, 'ارسال ناموفق بود')
  }
  finally {
    saving.value = false
  }
}
</script>
